import React from 'react';
import { useRecentPages } from '@shared/activity';
import { useLayoutPrefs } from '../layoutPrefs';
import { RecentHeader } from './RecentHeader';
import { RecentList } from './RecentList';
import { useIsDesktop } from './useIsDesktop';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@shared/ui/sheet';

export const RecentSidebar: React.FC = () => {
  const pages = useRecentPages();
  const { rightOpen, setRightOpen } = useLayoutPrefs();
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    if (!rightOpen) return null;

    return (
      <aside
        aria-label="Recent activity"
        className="w-72 border-l border-border bg-card flex flex-col shrink-0 h-[calc(100svh-var(--shell-header-h))] sticky top-[var(--shell-header-h)] z-30"
      >
        <RecentHeader
          hasItems={pages.length > 0}
          onClose={() => setRightOpen(false)}
        />
        <RecentList pages={pages} />
      </aside>
    );
  }

  return (
    <Sheet open={rightOpen} onOpenChange={setRightOpen}>
      <SheetContent side="right" className="w-80 p-0 flex flex-col">
        <SheetHeader className="sr-only">
          <SheetTitle>Recent Activity</SheetTitle>
        </SheetHeader>
        <RecentHeader
          hasItems={pages.length > 0}
          onClose={() => setRightOpen(false)}
        />
        <RecentList pages={pages} />
      </SheetContent>
    </Sheet>
  );
};
